import {
  collection,
  query,
  where,
  getDocs
} from "firebase/firestore";
import { db } from "../firebase";
import Cookies from "js-cookie";

export const Get_website_information = async (websiteuid) => {
  if (!websiteuid || websiteuid === "undefined" || websiteuid === "null") {
    return { success: false, error: "Contact service provider." };
  }

  try {
    const q = query(
      collection(db, "websiteservicesdb"),
      where("status", "==", true),
      where("suid", "==", websiteuid)
    );

    const snap = await getDocs(q);

    if (snap.empty) {
      return { success: false, error: "No record found." };
    }

    const data = snap.docs[0].data();
    return { success: true, data };
  } catch (err) {
    return { success: false, error: err.message || "Unknown error" };
  }
};
